const e = "This is an experimental generative AI chatbot. All information should be verified prior to use.", a = "Something went wrong. Try reloading the page and starting a new conversation.";
export {
  a as d,
  e as m
};
